module.exports = __webpack_public_path__ + "img/Болезнь Осгуда-Шлаттера.4484236b.jpg";